import axios from "axios";
import API_BASE_URL from "./BaseApiUrl";

export const publicPlayerEnqury = async (data) => {
  const res = await axios.post(
    `${API_BASE_URL}academic/v1/api/public/enquiry`,
    data,
  );
  return res.data;
};

export const publicPlayerRegistration = async (data) => {
  const res = await axios.post(
    `${API_BASE_URL}academic/v1/api/public/registration`,
    data,
  );
  return res.data;
};

export const paymentDetails = async (data) => {
  const res = await axios.post(
    `${API_BASE_URL}academic/v1/api/public/registration/payment`,
    data,
  );
  return res.data;
};

export const createRazorPayOrder = async (data) => {
  const res = await axios.post(
    `${API_BASE_URL}academic/v1/api/public/create/order`,
    data,
  );
  return res.data;
};

export const razorPayOrderVerify = async (data) => {
  const res = await axios.post(
    `${API_BASE_URL}academic/v1/api/public/verify/payment`,
    data,
  );
  return res.data;
};

export const publicPlayerCashPayment = async (data) => {
  const res = await axios.post(
    `${API_BASE_URL}academic/v1/api/public/player/config`,
    data,
  );
  return res.data;
};

export const getAllPublicFaqs = async (id) => {
  const res = await axios.get(
    `${API_BASE_URL}academic/v1/api/public/all/faqs/${id}`,
  );
  return res.data;
};

export const getPublicSubscription = async (id) => {
  const res = await axios.get(
    `${API_BASE_URL}academic/v1/api/public/player/subscription/${id}`,
  );
  return res.data;
};

export const getPublicExpensiveType = async () => {
  const res = await axios.get(
    `${API_BASE_URL}academic/v1/api/public/expensive/type`,
  );
  return res.data;
};

export const getPublicPaymentType = async () => {
  const res = await axios.get(
    `${API_BASE_URL}academic/v1/api/public/paymentType`,
  );
  return res.data;
};

export const getPublicDiscountType = async () => {
  const res = await axios.get(
    `${API_BASE_URL}academic/v1/api/public/player/discount/value/type`,
  );
  return res.data;
};

export const getPublicPlanType = async () => {
  const res = await axios.get(
    `${API_BASE_URL}academic/v1/api/public/player/discount/type`,
  );
  return res.data;
};

export const publicTenantRegistration = async (data, userId) => {
  const res = await axios.post(
    `${API_BASE_URL}academic/v1/api/public/create/tenant?userid=${userId}`,
    data,
  );
  return res.data;
};

export const publicTenantUserCreate = async (data) => {
  const res = await axios.post(
    `${API_BASE_URL}academic/v1/api/public/create/user`,
    data,
  );
  return res.data;
};

export const getPublicAgeCategory = async () => {
  const res = await axios.get(
    `${API_BASE_URL}academic/v1/api/public/age/category`,
  );
  return res.data;
};

export const getPublicDueTypeList = async () => {
  const res = await axios.get(
    `${API_BASE_URL}academic/v1/api/public/player/due/list/type`,
  );
  return res.data;
};

export const getPublicPaymentStatus = async () => {
  const res = await axios.get(
    `${API_BASE_URL}academic/v1/api/public/paymentStatus`,
  );
  return res.data;
};

// export const getPublicStatus = async () => {
//   const res = await axios.get(
//     `${API_BASE_URL}academic/v1/api/public/player/discount/value/type`,
//   );
//   return res.data;
// };

//reset password
export const publicOtpSend = async (payload) => {
  const res = await axios.post(
    `${API_BASE_URL}academic/v1/api/public/user/forget/password?email=${payload.email}`,
  );
  return res.data;
};

export const publicVerifyOtp = async (payload) => {
  const res = await axios.post(
    `${API_BASE_URL}academic/v1/api/public/user/verify/otp`,
    payload,
  );
  return res.data;
};

export const publicResetPassword = async (payload) => {
  const res = await axios.post(
    `${API_BASE_URL}academic/v1/api/public/reset/password`,
    payload,
  );
  return res.data;
};

export const publicPlayerPaymentHistory = async (id) => {
  const res = await axios.get(
    `${API_BASE_URL}academic/v1/api/public/player/detail/${id}`,
  );
  return res.data;
};

export const sendEmailOtp = async (payload) => {
  const res = await axios.post(
    `${API_BASE_URL}academic/v1/api/public/user/email/generate-otp?email=${payload.email}`,
  );
  return res.data;
};

export const verifyEmailOtp = async (payload) => {
  const res = await axios.post(
    `${API_BASE_URL}academic/v1/api/public/user/email/verify-otp`,
    payload,
  );
  return res.data;
};

export const getPublicTenantDetails = async (tenantId) => {
  const res = await axios.get(
    `${API_BASE_URL}academic/v1/api/public/tenant/${tenantId}`,
  );
  return res.data;
};

export const getPublicTenantLogoByFilename = async (filename) => {
  const res = await axios.get(
    `${API_BASE_URL}academic/v1/api/public/upload?filename=${filename}`,
  );
  return res.data;
};


export const PublicUploadLogo = async (file) => {
  const formData = new FormData();
  formData.append("file", file);

  try {
    const response = await axios.post(`${API_BASE_URL}academic/v1/api/public/logo`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    console.error("File upload failed:", error);
    throw error;
  }
};